import React from "react";
import { observer } from "mobx-react";

import { useRootAppStore } from "@hooks";
import { useTranslation } from "react-i18next";
import { Modal } from "@lib/modal";
import { Button } from "@components/buttons";
import { MobilePlatform } from "@state/stores/types";
import { isCapacitorPlatform } from "@utils/specific/capacitor";
import { useFixBody } from "@state/hooks/shared";

export default observer(function BankIdQrCodePopup() {
	const { bankIdCapacitorStore } = useRootAppStore<MobilePlatform>();

	const { t } = useTranslation("login");

	if (!isCapacitorPlatform()) {
		return null;
	}

	useFixBody(true, bankIdCapacitorStore.isBankIdQrCodePopupActive);

	return (
		<Modal>
			<div id="reuse-form" className="popup">
				<div className="popup__card">
					<div className="popup__header">
						<p className="popup__title">
							{t("BANK_ID.SCAN_QR_CODE")}
						</p>
						<button
							type="button"
							className="popup__close btn btn--square btn--square--sml btn--primary--inverted"
							title={t("COMMON.CLOSE")}
							onClick={() =>
								bankIdCapacitorStore.deactivateQrCodePopup()
							}
						>
							<i className="u-icon u-icon--tny u-icon--close u-color--text--secondary" />
						</button>
					</div>
					<div className="popup__body">
						<>
							{bankIdCapacitorStore.loaderStore
								.isLoadingProcess && (
								<div className="loader__spinner__wrapper">
									<div />
									<div />
									<div />
								</div>
							)}
							{bankIdCapacitorStore.qrCodeImage && (
								<img
									src={`data:image/svg+xml;base64,${btoa(
										bankIdCapacitorStore.qrCodeImage
									)}`}
								/>
							)}
						</>
					</div>
					<div className="popup__footer">
						<Button
							type="button"
							className="btn btn--base btn--block btn--primary"
							iconOnly={true}
							btnText={t("COMMON.CANCEL")}
							onClick={() => bankIdCapacitorStore.cancelAuth()}
						/>
					</div>
				</div>
			</div>
		</Modal>
	);
});
